/* ============
 * Actions for the auth module
 * ============
 *
 * The actions that are available on the
 * auth module.
 */

import Vue from 'vue'

import store from '@/app/store'
import * as types from './mutation-types'
import * as storageKeys from './storage-keys'

export async function check ({commit}) {
  const expiresAt = JSON.parse(Vue.$storage.get(storageKeys.EXPIRES_AT) || '[]')
  const isAuthenticated = new Date().getTime() < expiresAt
  commit(types.CHECK, isAuthenticated)
  if (isAuthenticated) {
    commit(types.SET_PERMISSIONS, ['admin', 'any'])
    await store.dispatch('account/find')
  }
}

export const renew = ({commit}, redirectTo) => {
  Vue.$auth.renew()
    .then((response) => {
      commit(types.LOGIN, response)
      commit(types.SET_PERMISSIONS, ['admin', 'any'])
      store.dispatch('account/find').then(() => {
        Vue.router.replace({
          name: redirectTo || 'start.index'
        })
      })
    })
    .catch((e) => {
      console.log(e.message)
      Vue.router.replace({
        name: 'login.index'
      })
    })
}

export const login = ({commit}) => {
  Vue.$auth.authenticate()
    .then((response) => {
      commit(types.LOGIN, response)
      commit(types.SET_PERMISSIONS, ['admin', 'any'])
      store.dispatch('account/find').then(() => {
        Vue.router.replace({
          name: 'start.index'
        })
      })
    })
}

export const logout = ({commit}) => {
  commit(types.LOGOUT)
  store.dispatch('account/reset')
  Vue.$auth.logout()
}

export default {
  check,
  renew,
  login,
  logout
}



// WEBPACK FOOTER //
// ./src/app/store/modules/auth/actions.js